import React, { Fragment, useMemo, useCallback } from 'react';
import { Route, Redirect, Switch, useHistory, useLocation } from 'react-router-dom';

import withAuthentication from 'Components/withAuthentication';
import navbarReduce from '../../shared/data/navbar/navbarReduce';
import TabRequest from './components/TabRequest';
import TabHistory from './components/TabHistory';
import Page from 'Components/Page';
import ReactGA from 'Shared/analytics';

const Expenses = ({ profileData }) => {
  const history = useHistory();
  const { pathname } = useLocation();

  const tabRouter = (
    <Fragment>
      <Route path="/employee/expenses" exact render={() => <Redirect to="/employee/expenses/request/" />} />
      <Switch>
        <Route path="/employee/expenses/request/" component={TabRequest} />
        <Route path="/employee/expenses/history/" component={TabHistory} />
      </Switch>
    </Fragment>
  );

  const activeTabId = useMemo(() => {
    return pathname.split('/')[3];
  }, [pathname]);

  const handleTabClick = useCallback(
    (tabClicked) => {
      if (tabClicked !== activeTabId) {
        history.push(`/employee/expenses/${tabClicked}/`);
        ReactGA.pageview(`/employee/expenses/${tabClicked}/`, 'Expenses' + tabClicked);
      }
    },
    [history, activeTabId]
  );

  return (
    <Page
      props={{
        className: 'expenses',
        titleProps: {
          text: 'Expenses',
        },
        navigation: {
          variant: 'tabs',
          tabsProps: {
            tabs: [
              {
                id: 'request',
                label: 'REQUEST',
              },
              {
                id: 'history',
                label: 'HISTORY',
              },
            ],
            onTabClick: handleTabClick,
            activeTabId,
          },
        },
        navbarProps: {
          points: navbarReduce(profileData),
          activePointId: 'expenses',
        },
        content: tabRouter,
      }}
    />
  );
};

export default withAuthentication(Expenses);
